import { z } from 'zod';
import { baseComponentSchema, buttonSchema } from '../component-base.schemas';

// FAQ component schemas
export const faqItemSchema = z.object({
  id: z.string().uuid('Invalid FAQ item ID'),
  question: z
    .string()
    .min(1, 'Question is required')
    .max(500, 'Question must be less than 500 characters'),
  answer: z
    .string()
    .min(1, 'Answer is required')
    .max(5000, 'Answer must be less than 5000 characters'),
  order: z.number().int().min(0).optional(),
});

export const faqCustomColorsSchema = z
  .object({
    background: z
      .string()
      .regex(/^#[0-9A-Fa-f]{6}$/)
      .optional(),
    title: z
      .string()
      .regex(/^#[0-9A-Fa-f]{6}$/)
      .optional(),
    subtitle: z
      .string()
      .regex(/^#[0-9A-Fa-f]{6}$/)
      .optional(),
    questionText: z
      .string()
      .regex(/^#[0-9A-Fa-f]{6}$/)
      .optional(),
    answerText: z
      .string()
      .regex(/^#[0-9A-Fa-f]{6}$/)
      .optional(),
    itemBackground: z
      .string()
      .regex(/^#[0-9A-Fa-f]{6}$/)
      .optional(),
    itemBorder: z
      .string()
      .regex(/^#[0-9A-Fa-f]{6}$/)
      .optional(),
    iconColor: z
      .string()
      .regex(/^#[0-9A-Fa-f]{6}$/)
      .optional(),
    buttonBg: z
      .string()
      .regex(/^#[0-9A-Fa-f]{6}$/)
      .optional(),
    buttonText: z
      .string()
      .regex(/^#[0-9A-Fa-f]{6}$/)
      .optional(),
  })
  .optional();

export const faqDataSchema = z.object({
  title: z
    .string()
    .min(1, 'FAQ section title is required')
    .max(200, 'Title must be less than 200 characters'),
  subtitle: z.string().max(500, 'Subtitle must be less than 500 characters').optional(),
  items: z.array(faqItemSchema).min(1, 'At least one FAQ item is required'),
  layout: z.enum(['accordion', 'list', 'grid']).default('accordion'),
  allowMultipleOpen: z.boolean().default(false),
  defaultOpenFirst: z.boolean().default(true),
  showNumbers: z.boolean().default(false),
  iconPosition: z.enum(['left', 'right', 'none']).default('right'),
  // NEW: Component-specific custom colors that override theme colors
  customColors: faqCustomColorsSchema,
  // Optional call-to-action buttons
  buttons: z.array(buttonSchema).optional(),
});

export const faqComponentSchema = baseComponentSchema.extend({
  type: z.literal('faq'),
  data: faqDataSchema,
});

// Type exports
export type FaqItem = z.infer<typeof faqItemSchema>;
export type FaqData = z.infer<typeof faqDataSchema>;
export type FaqComponent = z.infer<typeof faqComponentSchema>;
